/**
 * PDP image gallery — initializes the Swiper carousel behind the
 * product media gallery so the prev/next arrows actually work.
 *
 * Replaces the previous version, which called sliderInit()/subSliderInit()
 * — functions that were never defined anywhere in the theme — so the
 * gallery never initialized for real visitors (only appeared to "work"
 * inside the theme editor via the shopify:section:load listener, which
 * also referenced the same missing functions).
 */
(function () {
	function initGallery(wrapper) {
		if (!wrapper || wrapper.dataset.gallerySliderReady === 'true') return;

		var mainListEl = wrapper.querySelector('.js-media-list');
		if (!mainListEl || typeof Swiper === 'undefined') return;

		var subListEl = wrapper.querySelector('.js-media-sublist');
		var prevBtn = wrapper.querySelector('.swiper-btn--prev');
		var nextBtn = wrapper.querySelector('.swiper-btn--next');

		var thumbsSwiper = null;
		if (subListEl && subListEl.querySelectorAll('.swiper-slide').length > 1) {
			thumbsSwiper = new Swiper(subListEl, {
				direction: 'vertical',
				slidesPerView: 'auto',
				freeMode: true,
				watchSlidesProgress: true,
				spaceBetween: 8,
			});
		}

		var mainConfig = {
			slidesPerView: 1,
			spaceBetween: 0,
			watchOverflow: true,
			a11y: { enabled: true },
		};
		if (prevBtn && nextBtn) {
			mainConfig.navigation = { nextEl: nextBtn, prevEl: prevBtn };
		}
		if (thumbsSwiper) {
			mainConfig.thumbs = { swiper: thumbsSwiper };
		}

		var mainSwiper = new Swiper(mainListEl, mainConfig);

		wrapper.dataset.gallerySliderReady = 'true';
		wrapper._gallerySwipers = { main: mainSwiper, thumbs: thumbsSwiper };
	}

	function destroyGallery(wrapper) {
		if (!wrapper || !wrapper._gallerySwipers) return;
		try {
			if (wrapper._gallerySwipers.main) wrapper._gallerySwipers.main.destroy(true, true);
			if (wrapper._gallerySwipers.thumbs) wrapper._gallerySwipers.thumbs.destroy(true, true);
		} catch (e) {
			/* no-op — swiper may already be torn down */
		}
		wrapper._gallerySwipers = null;
		wrapper.dataset.gallerySliderReady = 'false';
	}

	function initAll() {
		document.querySelectorAll('.product__media-wrapper').forEach(initGallery);
	}

	function destroyAll() {
		document.querySelectorAll('.product__media-wrapper').forEach(destroyGallery);
	}

	function boot(attempt) {
		attempt = attempt || 0;
		if (typeof Swiper === 'undefined') {
			// Swiper loads as a separate deferred script; retry briefly if it
			// hasn't landed yet rather than failing silently.
			if (attempt < 20) setTimeout(function () { boot(attempt + 1); }, 50);
			return;
		}
		initAll();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { boot(0); });
	} else {
		boot(0);
	}

	// Re-init when the theme editor swaps section markup.
	document.addEventListener('shopify:section:load', function () {
		destroyAll();
		boot(0);
	});

	// Rebuild on resize so the thumbnail rail's direction/visibility
	// (desktop-only, per CSS) and slide sizing stay correct.
	var resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			destroyAll();
			boot(0);
		}, 200);
	});
})();
